import { InjectionToken } from '@angular/core';
import { JmkwEnvironment } from '@jeppesen-foreflight/jmkw-types';

export const CONFIG_TOKEN = new InjectionToken<Partial<JmkwEnvironment>>(
  'CONFIG_TOKEN'
);
